import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

const KEY = "crk_install_dismissed";

export default function InstallPrompt() {
  const [evt, setEvt] = useState(null);
  const [ios, setIos] = useState(false);
  const [hidden, setHidden] = useState(localStorage.getItem(KEY) === "1");
  useEffect(() => {
    const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone) {
      setHidden(true);
      return undefined;
    }
    setIos(/iphone|ipad|ipod/i.test(navigator.userAgent));
    const h = (e) => {
      e.preventDefault();
      setEvt(e);
    };
    window.addEventListener("beforeinstallprompt", h);
    return () => window.removeEventListener("beforeinstallprompt", h);
  }, []);
  if (hidden || (!evt && !ios)) return null;
  const close = () => {
    localStorage.setItem(KEY, "1");
    setHidden(true);
  };
  const install = async () => {
    evt.prompt();
    await evt.userChoice;
    setEvt(null);
    close();
  };
  return (
    <div data-testid="install-prompt" className="fade-up mt-3 flex items-center gap-3 rounded-2xl border border-brand-line bg-brand-soft p-3 text-sm">
      <img src="/icons/icon-192.png" alt="" className="h-10 w-10 rounded-xl" />
      <div className="min-w-0 flex-1">
        <div className="font-bold">Pasang Daily Tracker di layar utama</div>
        <div className="text-xs text-[#7a6667]">{evt ? "Buka lebih cepat seperti aplikasi." : "Ketuk tombol Bagikan lalu \"Tambah ke Layar Utama\"."}</div>
      </div>
      {evt && <button data-testid="install-button" onClick={install} className="btn-primary px-4"><Download size={15} /> Pasang</button>}
      <button data-testid="install-dismiss" onClick={close} aria-label="Tutup" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full hover:bg-white"><X size={16} /></button>
    </div>
  );
}
